export default "__VITE_ASSET__35c9364c__"